import Vue from 'vue'
import Loading from './loading.vue'
const loadingModal = Loading
let modalIndance
const init = () => {
  const Modal = Vue.extend(loadingModal)
  modalIndance = new Modal({})
  modalIndance.$mount()
  document.body.appendChild(modalIndance.$el)
  // modalIndance.$el.style.zIndex = 999999
}

const caller = () => {
  const option = {
    visible: true
  }
  if (!modalIndance) init(option)
  modalIndance.addOption(option)
}

const hide = () => {
  const option = {
    visible: false
  }
  if (!modalIndance) init(option)
  modalIndance.addOption(option)
}

export default {
  install (vue) {
    vue.prototype.$show = caller
    vue.prototype.$hide = hide
  }
}
